import React from "react";

const ExternalLinkIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13">
    <polyline
      points="11.5 9 11.5 11.5 1.5 11.5 1.5 1.5 4.5 1.5"
      fill="none"
      stroke="#1b69ff"
      strokeMiterlimit="10"
      strokeWidth="2"
    />
    <polyline
      points="6.793 1.621 11.379 1.621 11.379 6.207"
      fill="none"
      stroke="#1b69ff"
      strokeMiterlimit="10"
      strokeWidth="2"
    />
    <line
      x1="4.84315"
      y1="8.15685"
      x2="11.5"
      y2="1.5"
      fill="none"
      stroke="#1b69ff"
      strokeMiterlimit="10"
      strokeWidth="2"
    />
  </svg>
)

export default ExternalLinkIcon;